import { root } from './details';

export const details = {
  ...root,
};
